import { BrowserModule } from "@angular/platform-browser";
import { LOCALE_ID, NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { routing } from "./app-routing.module";

import { AppComponent } from "./app.component";
import { HomeComponent } from "./pages/home/home.component";
import { HomeEtablissementsComponent } from "./pages/homeEtablissements/homeEtablissements.component";
import { ProduitForfaitComponent } from "./pages/produitForfait/produitForfait.component";
import { ServiceEcoleComponent } from "./pages/serviceEcole/serviceEcole.component";
import { ContactEcoleComponent } from "./pages/contactEcole/contactEcole.component";
import { ContactGeneralComponent } from "./pages/contactGeneral/contactGeneral.component";
import { MentionsComponent } from "./pages/terms/mentions.component";
import { NotFoundComponent } from "./pages/notFound/notFound.component";
import { GroupByPipe } from "./pipes/groupBy.pipe";

import { ProduitComponent } from "./pages/produit/produit.component";
import { ProduitResolver } from "./pages/produit/produit.resolver";
import { ColonnesResolver } from "./pages/home/colonnes.resolver";
import { HPResolver } from "./pages/home/hp.resolver";
import { PavesResolver } from "./pages/home/paves.resolver";
import { OffresEmploiResolver } from "./pages/offres-emploi/offresEmploi.resolver";
import { OffresEmploiComponent } from "./pages/offres-emploi/offres-emploi.component";

import { DatePipe, registerLocaleData } from "@angular/common";
import localeFr from "@angular/common/locales/fr";
import { OffreEmploiResolver } from "./pages/offre-emploi/offreEmploi.resolver";
import { OffreEmploiComponent } from "./pages/offre-emploi/offre-emploi.component";
import { ContactCandidatComponent } from "./components/contact-candidat/contact-candidat.component";
import { CandidatureComponent } from "./pages/candidature/candidature.component";
import { InstanceEtProduitResolver } from "./pages/candidature/instanceEtProduit.resolver";
import { PostulerComponent } from "./pages/postuler/postuler.component";
import { PageModule } from "./pages/page.module";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatSelectModule } from "@angular/material/select";
import { MatIconModule } from "@angular/material/icon";
import { MatTabsModule } from "@angular/material/tabs";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatNativeDateModule } from "@angular/material/core";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { JwtModule } from "@auth0/angular-jwt";
import { MatRadioModule } from "@angular/material/radio";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { AuthComponent } from "./pages/auth/auth.component";
import { EntrepriseComponent } from "./pages/entreprise/entreprise.component";
import { SuivisComponent } from "./pages/suivis/suivis.component";

// the second parameter 'fr' is optional
registerLocaleData(localeFr, "fr");

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HomeEtablissementsComponent,
    ProduitForfaitComponent,
    ServiceEcoleComponent,
    ContactEcoleComponent,
    ContactGeneralComponent,
    MentionsComponent,
    NotFoundComponent,
    GroupByPipe,
    ProduitComponent,
    OffresEmploiComponent,
    OffreEmploiComponent,
    ContactCandidatComponent,
    CandidatureComponent,
    PostulerComponent,
    // AuthComponent,
    // EntrepriseComponent,
    // SuivisComponent,
  ],
  imports: [
    // Add .withServerTransition() to support Universal rendering.
    // The application ID can be any identifier which is unique on
    // the page.
    BrowserModule.withServerTransition({ appId: "frontend" }),
    HttpClientModule,
    PageModule,
    routing,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule,
    MatTabsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatRadioModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem("access_token");
        },
        whitelistedDomains: [
          "localhost",
          "2ftech.org",
          "2ftech.org/api",
          "crm.am.2ftech.org",
          "2ftech.org/icfa-full",
          "icfa-php.2ftech.org",
          "icfa-php.localhost",
          "apprentissage-montpellier.education",
          "www.apprentissage-montpellier.education",
        ],
        blacklistedRoutes: ["localhost/auth/login"],
      },
    }),
    NgbModule,
  ],
  providers: [
    ProduitResolver,
    ColonnesResolver,
    HPResolver,
    PavesResolver,
    OffresEmploiResolver,
    OffreEmploiResolver,
    InstanceEtProduitResolver,
    DatePipe,
    { provide: LOCALE_ID, useValue: "fr" },
  ],
  bootstrap: [AppComponent],
  entryComponents: [],
})
export class AppModule {}
